module.exports = __webpack_public_path__ + "img/34.0dae2c71.jpg";